import { render, staticRenderFns } from "./pdfViewerJS.vue?vue&type=template&id=05af65e0"
import script from "./pdfViewerJS.vue?vue&type=script&lang=js"
export * from "./pdfViewerJS.vue?vue&type=script&lang=js"
import style0 from "./pdfViewerJS.vue?vue&type=style&index=0&id=05af65e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports